module.exports = __webpack_public_path__ + "img/IT0003734208506.0ad2315b.svg";